function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { AbstractPlugin } from '../../shared/AbstractPlugin/AbstractPlugin.mjs';
var onSortableSorted = Symbol('onSortableSorted');
var onSortableSort = Symbol('onSortableSort');
var defaultOptions = {
  duration: 150,
  easingFunction: 'ease-in-out'
};

var SortAnimation = /*#__PURE__*/function (_AbstractPlugin) {
  _inherits(SortAnimation, _AbstractPlugin);

  var _super = _createSuper(SortAnimation);

  function SortAnimation(draggable) {
    var _this;

    _classCallCheck(this, SortAnimation);

    _this = _super.call(this, draggable);
    _this.options = _objectSpread(_objectSpread({}, defaultOptions), _this.getOptions());
    _this.lastAnimationFrame = null;
    _this.lastElements = [];
    _this[onSortableSorted] = _this[onSortableSorted].bind(_assertThisInitialized(_this));
    _this[onSortableSort] = _this[onSortableSort].bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SortAnimation, [{
    key: "attach",
    value: function attach() {
      this.draggable.on('sortable:sort', this[onSortableSort]);
      this.draggable.on('sortable:sorted', this[onSortableSorted]);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.draggable.off('sortable:sort', this[onSortableSort]);
      this.draggable.off('sortable:sorted', this[onSortableSorted]);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this.draggable.options.sortAnimation || {};
    }
  }, {
    key: onSortableSort,
    value: function value(_ref) {
      var dragEvent = _ref.dragEvent;
      var sourceContainer = dragEvent.sourceContainer;
      var elements = this.draggable.getDraggableElementsForContainer(sourceContainer);
      this.lastElements = Array.from(elements).map(function (el) {
        return {
          domEl: el,
          offsetTop: el.offsetTop,
          offsetLeft: el.offsetLeft
        };
      });
    }
  }, {
    key: onSortableSorted,
    value: function value(_ref2) {
      var _this2 = this;

      var oldIndex = _ref2.oldIndex,
          newIndex = _ref2.newIndex;

      if (oldIndex === newIndex) {
        return;
      }

      var effectedElements = [];
      var start;
      var end;
      var num;

      if (oldIndex > newIndex) {
        start = newIndex;
        end = oldIndex - 1;
        num = 1;
      } else {
        start = oldIndex + 1;
        end = newIndex;
        num = -1;
      }

      for (var i = start; i <= end; i++) {
        var from = this.lastElements[i];
        var to = this.lastElements[i + num];
        effectedElements.push({
          from: from,
          to: to
        });
      }

      cancelAnimationFrame(this.lastAnimationFrame);
      this.lastAnimationFrame = requestAnimationFrame(function () {
        effectedElements.forEach(function (element) {
          return animate(element, _this2.options);
        });
      });
    }
  }]);

  return SortAnimation;
}(AbstractPlugin);

function animate(_ref3, _ref4) {
  var from = _ref3.from,
      to = _ref3.to;
  var duration = _ref4.duration,
      easingFunction = _ref4.easingFunction;
  var domEl = from.domEl;
  var x = from.offsetLeft - to.offsetLeft;
  var y = from.offsetTop - to.offsetTop;
  domEl.style.pointerEvents = 'none';
  domEl.style.transform = "translate3d(".concat(x, "px, ").concat(y, "px, 0)");
  requestAnimationFrame(function () {
    domEl.addEventListener('transitionend', resetElementOnTransitionEnd);
    domEl.style.transition = "transform ".concat(duration, "ms ").concat(easingFunction);
    domEl.style.transform = '';
  });
}

function resetElementOnTransitionEnd(event) {
  event.target.style.transition = '';
  event.target.style.pointerEvents = '';
  event.target.removeEventListener('transitionend', resetElementOnTransitionEnd);
}

export { SortAnimation as default, defaultOptions };